import { useEffect, useRef, useState } from 'react'
import { Button, Dropdown, Nav } from 'react-bootstrap'
import { ColumnConfigurator } from '../../../CommonComponents/ColumnConfigurator'
import { Filter } from '../../../CommonComponents/Filter'
import DeleteModal from '../../DeleteModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faCalendarDay, faEllipsisVertical, faFileCsv, faFileExport, faFileImport, faPlus, faUser, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { IconLayout2, IconListDetails } from '@tabler/icons-react'
import { ExportDataPopup } from '../../../CommonComponents/ExportDataPopup'
import { toast } from 'sonner'
import useLocalStorageState from "use-local-storage-state"
import { DeleteRequest, GetRequest, PutRequest } from '../../../Utils/hooks/ApiHandler'
import { ManageListDropdown } from '../../../CommonComponents/ManageListDropdown'
import Tooltip from "@mui/material/Tooltip";
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'
import { DashboardCards } from './DashboardCards'
import { FilterQueryString } from '../../../CommonComponents/FilterQueryString'

export const ContactHeader = ({
    heading,
    setHeading,
    showCards,
    setShowCards,
    setSearch,
    currView,
    setActiveOffset,
    setCurrView,
    filterStates,
    setFilterState,
    filterCategories,
    setFilterCategories,
    columnOptions,
    columns,
    setColumns,
    setShow,
    setTempFilterData,
    setCurrAdvFilter,
    dropdownOptions,
    refetch,
    setCustomFilter,
    contactsMetadata,
    filterDropdown,
    setFilterDropdown,
    filterValues,
    setContactFilterValues
}) => {

    // getting essentials
    const { customer, setCustomer, navigate, headers, extras, customerId, loginUserId, userType } = useGetEssentials()

    const [PERMISSION, _] = useLocalStorageState("permission")

    // state for advancefilter 
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)
    const filterCategoriesDropRef = useRef(null)

    // filter states for searching function within the filter categories dropdown in header
    // filter seazrch bar input state
    const [filterSearchInput, setFilterSearchInput] = useState("")
    // Add states for filter pagination and search
    const [filterOffset, setFilterOffset] = useState(0)
    const [filterLimit, setFilterLimit] = useState(5)
    const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
    const [filterPageCount, setFilterPageCount] = useState(0)


    // fitered categories to store the search input filter categories
    const [filteredCategories, setFilteredCategories] = useState([])

    // isediting state for undoing the edit state in the filter name update in the heading dropdown
    const [editingId, setEditingId] = useState(false)

    // filter state to store the data to pass to delete and edit handler for filter
    const [filterData, setFilterData] = useState(null)
    // edit value state fot the filter card name edit
    const [editValue, setEditValue] = useState()
    // filter id to be edited
    const [editingFilterId, setEditingFilterId] = useState(null)
    // delete state for filter
    const [confirmFilterDelete, setFilterDelete] = useState(false)

    //delete modal Loading state
    const [loading, setLoading] = useState(false)

    // for searching through the whole contacts
    const [inputSearch, setInputSearch] = useState("")

    // export popup state
    const [exportPop, setExportPop] = useState(false)

    const exportFieldOptions = [
        { id: "company_name", label: "Company", required: true },
        { id: "contact_no", label: "Phone" },
        { id: "first_name", label: "First Name", required: true },
        { id: "last_name", label: "Last Name", required: true },
        { id: "email", label: "Email", required: true },
        { id: "phone", label: "Phone", required: true },
        { id: "owner", label: "Owner", required: true },
        { id: "address", label: "Address", required: false },
        { id: "country", label: "Country", required: true },
        { id: "state", label: "State", required: false },
        { id: "city", label: "City", required: false },
        { id: "zipcode", label: "Zipcode", required: false },
        { id: "facebook", label: "Facebook", required: false },
        { id: "instagram", label: "Instagram", required: false },
        { id: "twitter", label: "Twitter", required: false },
        { id: "linkedin", label: "Linked In", required: false },
        { id: "department", label: "Department", required: false },
        { id: "designation", label: "Designation", required: false },
        { id: "decision_maker", label: "Decision Maker", required: false },
        { id: "lead_source", label: "Lead Source", required: true },
        { id: "tag", label: "Tag", required: false },
        { id: "note", label: "Notes", required: false },
    ]
    const [exportFields, setExportFields] = useState(exportFieldOptions)

    // import fields for contacts
    const contactImportFields = [
        { id: "first_name", label: "First Name", required: true },
        { id: "last_name", label: "Last Name", required: true },
        { id: "owner", label: "Owner", required: true },
        { id: "report_to", label: "Report", required: false },
        { id: "email", label: "Email", required: true },
        { id: "phone", label: "Phone", required: true },
        { id: "address", label: "Address", required: false },
        { id: "country", label: "Country", required: true },
        { id: "state", label: "State", required: false },
        { id: "city", label: "City", required: false },
        { id: "zipcode", label: "Zipcode", required: false },
        { id: "facebook", label: "Facebook", required: false },
        { id: "twitter", label: "Twitter", required: false },
        { id: "linkedin", label: "Linkedin", required: false },
        { id: "instagram", label: "Instagram", required: false },
        { id: "company_name", label: "Company Name", required: false },
        { id: "lead_source", label: "Lead Source", required: true },
        { id: "department", label: "Department", required: false },
        { id: "tags", label: "Tags", required: false },
        { id: "designation", label: "Designation", required: false },
        { id: "decision_maker", label: "Decision Maker", required: false },
        { id: "notes", label: "Notes", required: false },
    ]

    // rbac permission for contact module.
    const contactGrants = PERMISSION.contact;

    // Debounced search effect
    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            setSearch(inputSearch.trim())
            setActiveOffset(0)
        }, 300)
        return () => clearTimeout(debounceTimer)
    }, [inputSearch])

    // debounce useeffect for filter search in filter categories dropdown
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilterSearch(filterSearchInput)
            setFilterOffset(0) // Reset to first page when search changes
        }, 300)

        return () => clearTimeout(timer)
    }, [filterSearchInput])

    // we should create a useeffect that will make sure that if any input search is there then we will show the respective filter with respect to the input else if input is null then no input would be shown
    useEffect(() => {
        if (!filterSearchInput || filterSearchInput.trim() === "") {
            // If no search input, show all categories
            setFilteredCategories(filterCategories)
        } else {
            // Filter categories based on search input
            const filtered = filterCategories.filter((category) =>
                category.card_name
                    .toLowerCase()
                    .includes(filterSearchInput.toLowerCase())
            )
            setFilteredCategories(filtered)
        }
    }, [filterSearchInput, filterCategories])

    // useeeffect for fetching the created advance filters
    const fetchFilterCardCategories = async () => {
        try {
            const res = await GetRequest(
                `contacts/fetchFilterCards/${customerId}/${loginUserId}?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )

            if (res.status === "fail" || res.success === false) {
                return
            }
            setFilterCategories(res.data)

            // Calculate page count if total_count is available in response
            if (res.total_count) {
                setFilterPageCount(Math.ceil(res.total_count / filterLimit))
            }
        } catch (error) {
            // toast.error("Error fetching filters")
            //shoservererror()()
            return
        }
    }

    useEffect(() => {
        fetchFilterCardCategories()
    }, [
        heading,
        // lastHeading,
        filterOffset,
        filterLimit,
        debouncedFilterSearch,
    ])

    // sub filter dropdown option
    const subFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "contains", label: "Contains" },
        { value: "not_contains", label: "Not-Contains" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
        { value: "is_empty", label: "Is Empty" },
        { value: "is_not_empty", label: "Is Not Empty" },
        { value: "begins_with", label: "Begins With" },
        { value: "between", label: "Between" },
    ]
    const customSubFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "is_set", label: "Is Set" },
        { value: "is_not_set", label: "Is Not Set" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
    ]

    const contactStaticListOptions = [
        {
            key: "All Contacts",
            icon: <FontAwesomeIcon
                icon={faUser}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Contacts Created By Me",
            icon: <FontAwesomeIcon
                icon={faUserPlus}
                style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Contacts Created Today",
            icon: <FontAwesomeIcon
                icon={faCalendarDay}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Contacts Created this Month",
            icon: <FontAwesomeIcon
                icon={faCalendar}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
    ]

    // edit handler for filter heading
    const handleFilterEdit = async () => {
        try {

            if (!editValue?.trim()) return
            if (!filterData) return

            const updatePayload = {
                customer_id: customerId,
                user_login_id: loginUserId,
                filter_id: filterData.id,
                card_name: editValue,
                description: "",
                module_name: "contact"
            }
            const res = await PutRequest(
                "common/updateFilterName",
                updatePayload,
                { headers },
                extras
            )

            if (res?.status === "fail" || res?.success === false) {
                toast.error(res?.message || "Error Updating Filter")
                setFilterDropdown(false)
                return
            }

            setHeading(editValue.trim())
            // setIsEditing(false)
            setEditingFilterId(null)
            setFilterDropdown(false)
            fetchFilterCardCategories()
            toast.success(res?.message)
        } catch (error) {
            // toast.error("Error Updating Filter")
            return
        }
    }

    // delete handler for filter delete
    const handleFilterDelete = async () => {
        setLoading(true)
        try {
            if (filterData === null) return
            const res = await DeleteRequest(
                `contacts/deleteFilter/${filterData.id}`,
                { headers },
                extras
            )
            if (res.status === "fail") {
                setLoading(false)
                toast.error(res.message)
                return
            }
            if (res.success === false) {
                setLoading(false)
                toast.error(res.message)
            }
            setCustomFilter(null)
            setFilterDropdown(false)
            setFilterDelete(false)
            setHeading("All Contacts")
            fetchFilterCardCategories()
            setFilterOffset(0)
            refetch()
            localStorage.setItem("contactsMetadata", JSON.stringify({
                ...contactsMetadata,
                filterType: {
                    filterName: "All Contacts",
                    id: null
                }
            }))
            toast.success(res.message)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Error Deleting Filter")
            return
        }
    }

    const handleFilterPageChange = (newOffset) => {
        setFilterOffset(newOffset.selected)
    }

    return (
        <>
            <div className="d-flex justify-content-between align-content-center px-0 w-100 py-2">

                <div
                    className="d-flex align-items-center gap-1"
                    style={{ zIndex: 101 }}
                >
                    <h3
                        className="mb-0 me-1"
                        style={{ fontWeight: 200, fontSize: "22px", textTransform: "capitalize" }}
                    >
                        {heading}
                    </h3>
                    {/* heading filter dropdown */}
                    <ManageListDropdown
                        heading={heading}
                        setHeading={setHeading}
                        categories={filterCategories}
                        storageKey="contactsMetadata"
                        metadata={contactsMetadata}
                        setTempFilterData={setTempFilterData}
                        onEdit={(c) => setFilterData(c)}
                        onDelete={(c) => {
                            setFilterData(c)
                            setFilterDelete(true)
                        }}
                        onUpdate={(c) => {
                            setFilterData(c)
                            handleFilterEdit()
                        }}
                        staticOptions={contactStaticListOptions}
                        filterOffset={filterOffset}
                        setFilterOffset={setFilterOffset}
                        handleFilterPageChange={handleFilterPageChange}
                        filterPageCount={filterPageCount}
                        filterLimit={filterLimit}
                        editValue={editValue}
                        setEditValue={setEditValue}
                        editingFilterId={editingFilterId}
                        setEditingFilterId={setEditingFilterId}
                        canEdit_canDownload={true}
                        setCustomFilter={setCustomFilter}
                        filterQueryKey={"contactApplyFilterQueryValues"}
                        setCurrAdvFilter={setCurrAdvFilter}
                    />

                    {confirmFilterDelete && (
                        <DeleteModal
                            show={confirmFilterDelete}
                            onClose={() => setFilterDelete(false)}
                            onConfirm={() => handleFilterDelete(filterData)}
                            isLoading={loading}
                            message="Are you sure you want to delete this item?"

                        ></DeleteModal>
                    )}
                    <div className="form-check form-switch ms-3">
                        {console.log("cards state", !showCards)}
                        <Tooltip id="tooltip-top"
                            title={showCards ? "Show contact card" : "Hide contact card"}
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                role="switch"
                                checked={!showCards}
                                onChange={() => setShowCards(!showCards)}
                            />
                        </Tooltip>
                    </div>
                </div>

                {/* create contact button */}
                <div
                    className="d-flex align-content-center gap-1"
                    style={{ height: "35px" }}
                >
                    {/* search bar */}
                    <div className=" position-relative">
                        <input
                            type="text"
                            style={{ fontSize: "12px", paddingLeft: "36px" }}
                            className="form-control h-100"
                            value={inputSearch}
                            placeholder='Search Here...'
                            onChange={(e) => {
                                setInputSearch(e.target.value)
                                setActiveOffset(0)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault()
                                    setSearch(inputSearch)
                                    setActiveOffset(0)
                                }
                            }}
                        />
                        <i
                            className="fa-solid fa-magnifying-glass"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                marginLeft: "13px",
                            }}
                        ></i>
                        {inputSearch.length > 0 && (
                            <i
                                className="fa-solid fa-xmark"
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    right: 0,
                                    marginRight: "13px",
                                    cursor: "pointer",
                                }}
                                onClick={() => setInputSearch("")}
                            ></i>
                        )}
                    </div>

                    {/* list and card views */}
                    <div
                        className="px-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 5,
                            border: "1px solid #7a3a5e69",
                            borderRadius: "3px",
                            background: "#ffffff",
                            padding: "4px 8px",
                        }}
                    >
                        {/* Card View Button */}
                        <button
                            type="button"
                            onClick={() => {
                                setCurrView("card")
                            }}
                            style={{
                                border: 'none',
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    currView === "card" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconLayout2
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "card" ? "#212121" : "#212121",
                                }}
                            />
                        </button>
                        {/* List View Button */}
                        <button
                            type='button'
                            className=""
                            onClick={() => {
                                setCurrView("list")
                            }}
                            style={{
                                border: 'none',
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    currView === "list" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconListDetails
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "list" ? "#212121" : "#212121",
                                }}
                            />
                        </button>
                    </div>


                    {/* advance filtering */}
                    <Filter
                        filterDropdown={filterDropdown}
                        canEdit_canDownload={true}
                        setFilterDropdown={setFilterDropdown}
                        dropdownOptions={dropdownOptions}
                        filterState={filterStates}
                        setFilterState={setFilterState}
                        setHeading={setHeading}
                        subFilter={subFilter}
                        customSubFilter={customSubFilter}
                        module_name={"contacts"}
                        setTempFilterData={setTempFilterData}
                        setCurrAdvFilter={setCurrAdvFilter}
                        filterEndpoint={"contacts/filterQuery"}
                        applyQuery={"contacts/applyFilter"}
                        view={currView == "list" ? "list" : "card"}
                        setOffset={setActiveOffset}
                        setCustomFilter={setCustomFilter}
                        storageKey={"contactsMetadata"}
                        metadata={contactsMetadata}
                        filterQueryKey={"contactApplyFilterQueryValues"}
                    ></Filter>

                    {/* Gear icon dropdown with drag and drop */}
                    {
                        currView === "list" &&
                        <ColumnConfigurator
                            columnOptions={columnOptions}
                            columns={columns}
                            setColumns={setColumns}
                            storageKey="contactsMetadata"
                            metadata={contactsMetadata}
                        />

                    }

                    <Dropdown
                        as="div"
                        className="dropdownsWithoutToggle"
                    >
                        <Dropdown.Toggle as={Nav.Link} className="header-link">
                            <button
                                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                                style={{
                                    fontSize: "1rem",
                                    alignItems: "center",
                                    height: "35px",
                                    width: "2.5rem",
                                }}
                            >
                                {" "}
                                <FontAwesomeIcon
                                    style={{
                                        width: "15px",
                                        height: "15px",
                                    }}
                                    icon={faEllipsisVertical}
                                />
                            </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="defaultDropdown dropdown-menu-end "
                            style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
                        >
                            <Dropdown.Item href="#"
                                onClick={() => {
                                    if (!contactGrants?.isImport) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    navigate("/importdata", {
                                        state: {
                                            module_name: "contact",
                                            fieldData: [{
                                                title: "General Fields",
                                                fields: contactImportFields.map(c => c)
                                            }]
                                        }
                                    })
                                }}
                                className="d-flex align-items-center">
                                <FontAwesomeIcon
                                    icon={faFileImport}
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                    }}
                                />{" "}
                                Import Data
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    if (contactGrants?.isExport) {
                                        setExportPop(true)
                                        return
                                    }
                                    toast.warning("You are not authorized for this actions!")
                                }}
                                className="d-flex align-items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faFileExport}
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                    }}
                                />{" "}
                                Export Data
                            </Dropdown.Item>
                            {exportPop && (
                                <ExportDataPopup
                                    exportPop={exportPop}
                                    setExportPop={setExportPop}
                                    exportfields={exportFields}
                                    setExportfields={setExportFields}
                                    heading={"Export Contacts Data"}
                                    handleClose={() => setExportPop(false)}
                                    exportData={exportFields.map((c) => c.id)}
                                    module_name="contact"
                                    fields={exportFieldOptions}
                                    selectedFields={exportFields}
                                ></ExportDataPopup>
                            )}
                            <Dropdown.Item href="#" className="d-flex align-items-center">
                                <FontAwesomeIcon
                                    icon={faFileCsv}
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                    }}
                                />{" "}
                                Template
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* create contact button */}
                    <Button
                        type="button"
                        className="btn btn-default"
                        style={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => {
                            if (!contactGrants?.isCreate) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            setShow(true)
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
                    </Button>
                </div>
            </div >
            {/* to show the current applied filters  */}
            <FilterQueryString
                filterValues={filterValues}
                setCurrAdvFilter={setCurrAdvFilter}
                setTempFilterData={setTempFilterData}
                setFilterState={setFilterState}
                setFilterValues={setContactFilterValues}
            />
            <DashboardCards
                heading={heading}
                headers={headers}
                extras={extras}
                show={showCards}
            />
        </>
    )
}